import RemoveButton from './options/RemoveButton';

export default function Photos({ photo, handleView, state, handleRemove }) {
	return (
		<div
			onClick={() => (!state ? handleView(photo) : null)}
			className={`photo ys-classic`}
			style={{ backgroundImage: `url('${photo}')` }}
		>
			{state && <RemoveButton handleRemoveState={handleRemove} />}
		</div>
	);
}
